import moment from 'moment';
import {
    FETCH_YARN_PROJECTION_REQUEST,
    FETCH_YARN_PROJECTION_SUCCESS,
    FETCH_YARN_PROJECTION_FAILURE,
    CREATE_YARN_PROJECTION_FORM,
    UPDATE_YARN_PROJECTION_FORM,
    CREATE_YARN_PROJECTION_SUCCESS,
    FETCH_SINGLE_YARN_PROJECTION_SUCCESS,
    UPDATE_YARN_PROJECTION_SUCCESS,
    DELETE_YARN_PROJECTION_SUCCESS,
    CREATE_YARN_PROJECTION_REQUEST,
    UPDATE_YARN_PROJECTION_REQUEST,
    FETCH_SINGLE_YARN_PROJECTION_REQUEST,
    DELETE_YARN_PROJECTION_REQUEST,
    RESET_YARN_PROJECTION_INFO,
    CREATE_YARN_PROJECTION_FAILURE,
    UPDATE_YARN_PROJECTION_FAILURE,
    FETCH_SINGLE_YARN_PROJECTION_FAILURE,
    DELETE_YARN_PROJECTION_FAILURE,
    FETCH_PRNO_REQUEST,
    FETCH_PRNO_SUCCESS,
    FETCH_PRNO_FAILURE,
    FETCH_COMBINED_SL_NO_SUCCESS,
    FETCH_COMBINED_SL_NO_FAILURE,
    FETCH_COMBINED_SL_NO_REQUEST,
    FETCH_YARN_PROJECTION_REPORTS_REQUEST,
    FETCH_YARN_PROJECTION_REPORTS_FAILURE,
    FETCH_YARN_PROJECTION_REPORTS_SUCCESS,
    RESET_COMBINED_SL_NO,
    NOT_RESET_ADD_NEW_BTN,
    FETCH_YARN_PROJECTION_REPORTS_OVERALL_REQUEST,
    FETCH_YARN_PROJECTION_REPORTS_OVERALL_SUCCESS,
    FETCH_YARN_PROJECTION_REPORTS_OVERALL_FAILURE,
    FETCH_YARN_PROJECTION_OUTSTANDING_SUCCESS,
    FETCH_YARN_PROJECTION_OUTSTANDING_REQUEST,
    FETCH_YARN_PROJECTION_OUTSTANDING_FAILURE,
    //UPDATE_FLD_SUBJECT // subject validations 0407
} from './yarnProjection.actionsType';

export const YARN_PROJECTION = 'yarnProjection';

let initialState = {
    loading: false,
    yarnProjectionList: [],
    yarnProjectionForm: {
        // fldFKUnitId:'',
        // fldFKSupplierID: '',
        fldGroupPRNo: '',
        fldCombinedSlNo: '',
        fldFKMillName: '',
        fldFKAgentName: '',
        fldFKYarn: '',
        fldBagWeight: '',
        fldNoofBags: '',
        // fldPRWeight:'',
        fldRate: '',
        fldRemarks: ''

    },
    selectedState: {},
    errorMessage: '',
    prNo: '',
    combinedSlNo: '',
    yarnProjectionFormData: {},
    yarnProjectionReportsList: [],
    yarnProjectionOverAllReport: []
    // fldSubject: '',  // Add fldSubject to the initial state
};

export let yarnProjectionReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_YARN_PROJECTION_REQUEST:
        case CREATE_YARN_PROJECTION_REQUEST:
        case UPDATE_YARN_PROJECTION_REQUEST:
        case FETCH_SINGLE_YARN_PROJECTION_REQUEST:
        case DELETE_YARN_PROJECTION_REQUEST:
        case FETCH_COMBINED_SL_NO_REQUEST:
        case FETCH_PRNO_REQUEST:
        case FETCH_YARN_PROJECTION_REPORTS_REQUEST:
        case FETCH_YARN_PROJECTION_REPORTS_OVERALL_REQUEST:
        case FETCH_YARN_PROJECTION_OUTSTANDING_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_PROJECTION_SUCCESS:
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            let disableFabricProjection = state.yarnProjectionList.filter((x) => x.fldPRDate.split('T')[0] === currentDate)
            const lastObject = disableFabricProjection[disableFabricProjection.length - 1];
            return {
                ...state,
                loading: false,
                yarnProjectionList: updatePayload,

            };
        case FETCH_YARN_PROJECTION_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnProjectionReportsList: updatePayload
            }
        case FETCH_YARN_PROJECTION_REPORTS_OVERALL_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnProjectionOverAllReport: updatePayload
            }
        case FETCH_YARN_PROJECTION_OUTSTANDING_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnProjectionOutStanding: updatePayload
            }

        case CREATE_YARN_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnProjectionForm: {
                    fldGroupPRNo: '',
                    fldCombinedSlNo: '',
                    fldFKMillName: '',
                    fldFKAgentName: '',
                    fldFKYarn: '',
                    fldBagWeight: '',
                    fldNoofBags: '',
                    fldRate: '',
                    fldRemarks: '',
                    fldIsFabricProjection: state.yarnProjectionForm?.fldIsFabricProjection

                }
            };
        case FETCH_PRNO_SUCCESS:
            // Assuming updatePayload is the response array
            // const lastRecord = action.updatePayload[action.updatePayload.length - 1];

            return {
                ...state,
                // prNo: updatePayload.fldGroupPRNo,
                prNo: updatePayload,
                // fldSubject: lastRecord.fldSubject,  // Update fldSubject with the value from the last record

                loading: false
            };
        // subject validations 0407
        // case UPDATE_FLD_SUBJECT:
        // return {
        //     ...state,
        //     prNo: action.payload,
        // }; 
        case FETCH_COMBINED_SL_NO_SUCCESS:
            return {
                ...state,
                combinedSlNo: updatePayload,
                loading: false
            };
        case RESET_COMBINED_SL_NO:
            return {
                ...state,
                combinedSlNo: 1,
                loading: false
            }
        case UPDATE_YARN_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnProjectionForm: {}
            };
        case FETCH_SINGLE_YARN_PROJECTION_SUCCESS:
            // const currentDate = moment(new Date()).format('YYYY-MM-DD')
            // let disableFabricProjection = state.yarnProjectionList.filter((x) => x.fldPRDate.split('T')[0] === currentDate)
            // const lastObject = disableFabricProjection[disableFabricProjection.length - 1];
            return {
                ...state,
                loading: false,
                // yarnProjectionForm: { ...updatePayload, fldIsFabricProjection: lastObject.fldIsFabricProjection || false }
                yarnProjectionForm: updatePayload
            };
        case DELETE_YARN_PROJECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnProjectionForm: {
                    // fldFKUnitId:'',
                    // fldFKSupplierID: '',
                    fldGroupPRNo: '',
                    fldCombinedSlNo: '',
                    fldFKMillName: '',
                    fldFKAgentName: '',
                    fldFKYarn: '',
                    fldBagWeight: '',
                    fldNoofBags: '',
                    // fldPRWeight:'',
                    fldRate: '',
                    fldRemarks: ''

                }
            };
        case RESET_YARN_PROJECTION_INFO:
            return {
                ...state,
                yarnProjectionForm: {
                    // fldFKUnitId:'',
                    //fldFKSupplierID: '',
                    fldGroupPRNo: '',
                    fldCombinedSlNo: '',
                    fldFKMillName: '',
                    fldFKAgentName: '',
                    fldFKYarn: '',
                    fldBagWeight: '',
                    fldNoofBags: '',
                    // fldPRWeight:'',
                    fldRate: '',
                    fldRemarks: ''

                },
                prNo: '',
                combinedSlNo: ''
            };
        case CREATE_YARN_PROJECTION_FORM:
        case UPDATE_YARN_PROJECTION_FORM:
            return {
                ...state,
                loading: false,
                yarnProjectionForm: {
                    ...state.yarnProjectionForm,
                    [payload.key]: payload.value
                },
                yarnProjectionFormData: {
                    ...state.yarnProjectionFormData,
                    [payload.key]: payload.value
                },
            };


        case FETCH_YARN_PROJECTION_FAILURE:
        case CREATE_YARN_PROJECTION_FAILURE:
        case UPDATE_YARN_PROJECTION_FAILURE:
        case FETCH_SINGLE_YARN_PROJECTION_FAILURE:
        case DELETE_YARN_PROJECTION_FAILURE:
        case FETCH_PRNO_FAILURE:
        case FETCH_COMBINED_SL_NO_FAILURE:
        case FETCH_YARN_PROJECTION_REPORTS_FAILURE:
        case FETCH_YARN_PROJECTION_REPORTS_OVERALL_FAILURE:
        case FETCH_YARN_PROJECTION_OUTSTANDING_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
